/**
 * This file can contain helper functions related to URLs
 */

export function replaceLinks(message: string) {
  if (message?.length) {
    const regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
    return message.replace(regex, (match) => `<a target="_blank" href="${addProtocolToUrl(match)}">${match}</a>`);
  }
  return message;
}

export function extractAllLinks(message: string) {
  if (message?.length) {
    const regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
    return message.match(regex);
  }
  return [];
}

export function hasLink(message: string) {
  if (message?.length) {
    const regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
    return regex.test(message);
  }
  return false;
}

export function replaceEmails(message: string) {
  if (message?.length) {
    const regex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g;
    return message.replace(regex, (match) => `<a href="mailto:${match}">${match}</a>`);
  }
  return message;
}

export function addProtocolToUrl(url: string) {
  if (url.indexOf("://") < 0) {
    return `http://${url}`;
  }
  return url;
}
